import { Button, Input } from 'antd';
import { useTranslation } from 'react-i18next';

type Props = {
  nameEn: string;
  nameFr: string;
  onChangeNameEn: (v: string) => void;
  onChangeNameFr: (v: string) => void;
  /** When provided, renders its own Save button (the Field editor's case — name and
   *  field content save independently). Omitted for Section/Step, where the page's
   *  single explicit Save button covers the name alongside the structural edits. */
  onSave?: () => void;
  saving?: boolean;
};

/** The custom element's own library name (EN/FR) — distinct from the field's label / section's title / step's title, which are edited in the panel below. */
export function NameFields({
  nameEn,
  nameFr,
  onChangeNameEn,
  onChangeNameFr,
  onSave,
  saving,
}: Props) {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: 'flex',
        gap: 8,
        alignItems: 'flex-end',
        marginTop: 12,
        maxWidth: 640,
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 12,
        padding: '12px 16px',
      }}
    >
      <div style={{ flex: 1 }}>
        <label
          style={{
            fontSize: 12,
            fontWeight: 600,
            color: '#6b7280',
            display: 'block',
            marginBottom: 4,
          }}
        >
          {t('workflow.customElements.nameEn')}
        </label>
        <Input value={nameEn} onChange={(e) => onChangeNameEn(e.target.value)} maxLength={120} />
      </div>
      <div style={{ flex: 1 }}>
        <label
          style={{
            fontSize: 12,
            fontWeight: 600,
            color: '#6b7280',
            display: 'block',
            marginBottom: 4,
          }}
        >
          {t('workflow.customElements.nameFr')}
        </label>
        <Input value={nameFr} onChange={(e) => onChangeNameFr(e.target.value)} maxLength={120} />
      </div>
      {onSave && (
        <Button type="primary" loading={saving} onClick={onSave}>
          {t('common.save')}
        </Button>
      )}
    </div>
  );
}
